<template>
  <div class="modal-container">
    <div class="form-group">
      <FileLocalMultiUploadRedesigned
        v-model="files"
        title="Загрузка файла"
        label="Выберите файл"
        :accept="accept"
        isOnce
        showEmpty
      />

      <div class="invalid-msg mt-3 fira-sans" v-if="v$.files.$error">Поле обязательно для заполнения</div>
    </div>
    <div class="buttons-container">
      <ButtonComponent mod="gradient-bg" @click="doImport">Загрузить</ButtonComponent>
      <ButtonComponent mod="transparent-bg" @click="close">Закрыть</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import FileLocalMultiUploadRedesigned from '@/common/components/redesigned/fileUploads/FileLocalMultiUploadRedesigned.vue';

  export default {
    name: 'ImportModalRedesigned',
    components: { ButtonComponent, FileLocalMultiUploadRedesigned },
    emits: ['doimport', 'close'],
    props: {
      acceptType: String,
    },
    data() {
      return {
        files: [],
        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      };
    },
    created() {
      if (this.acceptType) this.accept = this.acceptType;
    },
    methods: {
      doImport() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          return;
        }
        const [file] = this.files;
        this.$emit('doimport', file);
        this.reset();
      },
      close() {
        this.reset();
        this.$emit('close');
      },
      reset() {
        this.files = [];
        this.v$.$reset();
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        files: { required },
      };
    },
  };
</script>

<style scoped lang="scss">
  .modal-container {
    margin-top: 24px;
  }

  .buttons-container {
    display: flex;
    gap: 8px;
    margin-top: 32px;

    @media (max-width: $mobile) {
      flex-direction: column;
    }
  }
</style>
